import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const RefundPolicy = () => {
  return (
    <>
      <SEO 
        title="Exchange Policy (No Returns)"
        description="SCAN Exchange Policy: No returns or refunds. Exchanges only within 2 days (48 hours) on eligible items. Read full terms for eligibility, process, and shipping charges."
        keywords="exchange policy, no returns, no refunds, exchange process, SCAN by Deepak Raj, House of Deepak policy"
      />
      <div className="min-h-screen bg-cream pt-20 pb-16">
        <div className="section-padding">
          <div className="container-max">
            <motion.div
              className="max-w-4xl mx-auto"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {/* Header */}
              <div className="text-center mb-16">
                <h1 className="text-4xl md:text-6xl font-serif font-light text-deep-brown mb-6">
                  Exchange Policy (No Returns)
                </h1>
                <p className="text-lg text-warm-gray max-w-2xl mx-auto leading-relaxed">
                  Last updated: October 18, 2025
                </p>
              </div>

              {/* Content */}
              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="p-8 md:p-12 space-y-8">
                  {/* Intro */}
                  <section>
                    <p className="text-warm-gray leading-relaxed">
                      At SCAN, customer satisfaction is our priority. However, please note that we do not offer returns or refunds under any circumstances. We only provide exchange on eligible products, as per the following terms and conditions:
                    </p>
                  </section>

                  {/* 1. No Returns / Refunds */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">1. No Returns / Refunds</h3>
                    <p className="text-warm-gray leading-relaxed">
                      Once an order is delivered, it cannot be returned or refunded. Only exchanges are accepted.
                    </p>
                  </section>

                  {/* 2. Exchange Request Window */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">2. Exchange Request Window</h3>
                    <ul className="text-warm-gray leading-relaxed space-y-1 list-disc list-inside ml-4">
                      <li>Exchange requests must be placed within <strong>2 days (48 hours)</strong> of receiving the product.</li>
                      <li>Requests made after 2 days will not be accepted.</li>
                    </ul>
                  </section>

                  {/* 3. Exchange Eligibility */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">3. Exchange Eligibility</h3>
                    <ul className="text-warm-gray leading-relaxed space-y-2 list-disc list-inside ml-4">
                      <li>Product must be <strong>unused, unwashed, and in original condition</strong> with tags and packaging intact.</li>
                      <li>Products showing signs of wear or damage will not be accepted for exchange.</li>
                      <li>Items purchased during <strong>sale, discount offers, or clearance</strong> are not eligible for exchange.</li>
                    </ul>
                  </section>

                  {/* 4. Exchange Options */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">4. Exchange Options</h3>
                    <ul className="text-warm-gray leading-relaxed space-y-2 list-disc list-inside ml-4">
                      <li>You may exchange your item for the <strong>same product in a different size</strong> or for <strong>any other design of the same value</strong>.</li>
                      <li>If you choose a product of higher value, you must pay the price difference.</li>
                      <li>If the product you want to exchange is of lower value, the price difference will <strong>not be refunded</strong>.</li>
                    </ul>
                  </section>

                  {/* 5. Exchange Process */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">5. Exchange Process</h3>
                    <p className="text-warm-gray leading-relaxed mb-3">
                      To initiate an exchange, please contact us via <strong>info@houseofdeepak.in</strong> or WhatsApp <strong>+91 9167602861</strong> within 2 days of delivery. Our team will guide you through the process and provide the return pickup or courier address.
                    </p>
                  </section>

                  {/* 6. Shipping Charges */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">6. Shipping Charges</h3>
                    <p className="text-warm-gray leading-relaxed">
                      Customers are responsible for the <strong>two-way shipping cost</strong> (sending and receiving the exchanged item).
                    </p>
                  </section>

                  {/* 7. Exchange Approval */}
                  <section>
                    <h3 className="text-xl font-serif text-deep-brown mb-3">7. Exchange Approval</h3>
                    <p className="text-warm-gray leading-relaxed">
                      Exchange will be processed only after we receive and inspect the returned item. If the product does not meet our policy conditions, it will be sent back without exchange.
                    </p>
                  </section>

                  {/* Support */}
                  <section className="bg-cream p-6 rounded-lg">
                    <h4 className="font-medium text-deep-brown mb-2">Support</h4>
                    <p className="text-warm-gray leading-relaxed">
                      For any questions regarding the exchange policy, contact us at <strong>info@houseofdeepak.in</strong>.
                    </p>
                  </section>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;